export default __webpack_public_path__ + "static/media/preview.3ce1f337.gif";